import { useTranslation } from 'react-i18next'

interface HeaderWelcomeProps {
  firstName: string
  isLight?: boolean
  className?: string
}

// « Bonjour {prénom} » dans une pastille avec l'initiale du prénom, à côté du
// bouton de déconnexion. Un prénom vide (compte sans prénom renseigné)
// n'affiche rien plutôt qu'un « Bonjour » tout seul. Un prénom long est
// tronqué ; le texte complet reste disponible au survol (title).
export const HeaderWelcome = ({
  firstName,
  isLight,
  className = '',
}: HeaderWelcomeProps) => {
  const { t } = useTranslation('layout')

  const name = firstName.trim()
  if (!name) return null

  const label = t('header.welcome', { name })
  // Array.from : premier caractère réel, y compris hors plan basique (emoji…).
  const initial = Array.from(name)[0].toLocaleUpperCase('fr')

  return (
    <span
      title={label}
      className={`flex min-w-0 max-w-[16rem] items-center gap-2.5 rounded-full py-1 pl-1.5 pr-4 text-lg font-bold ${
        isLight ? 'bg-orange-100 text-black' : 'bg-white/20 text-white'
      } ${className}`}
    >
      <span
        aria-hidden="true"
        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white ${
          isLight ? 'bg-gradient-orange-fuschia' : 'bg-white/30'
        }`}
      >
        {initial}
      </span>
      <span className="truncate">{label}</span>
    </span>
  )
}
